import { type ReactElement } from "react";
import { useDarkMode, useLanguage } from "@/context";
import { t } from "@/data";
import Sun from "@/assets/images/light-mode.webp";
import Moon from "@/assets/images/dark-mode.webp";

export const Toggle = (): ReactElement => {
  const { darkMode, toggleDarkMode } = useDarkMode();
  const { lang } = useLanguage();

  return (
    <div className="toggle">
      <button
        onClick={toggleDarkMode}
        aria-label={darkMode ? t(lang, "toggleLight") : t(lang, "toggleDark")}
        type="button"
      >
        <img
          src={darkMode ? Moon : Sun}
          alt=""
          className="toggle-icon"
          width={48}
          height={22}
        />
      </button>
    </div>
  );
};
